export default function KandinskyLogo() {
  return <img src="/logos/kandinsky-logo.png" alt="Kandinsky Lab" width="16" height="16" className="block" />
}
